/**
 * SiteHeader.tsx — Navigare globală reutilizabilă
 * Link-urile cu hash (#why, #services etc.) funcționează atât pe homepage cât și din alte pagini (via /#services)
 */

import { useState } from "react";
import { useLocation } from "wouter";
import { Menu, X, Globe } from "lucide-react";

// Dacă suntem pe homepage, folosim hash direct; altfel prefixăm cu /
function navHref(href: string, isHome: boolean): string {
  if (href.startsWith("#")) {
    return isHome ? href : `/${href}`;
  }
  return href;
}

const NAV_LINKS = [
  { label: "Why Brașov", href: "#why-brasov" },
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [location] = useLocation();
  const isHome = location === "/";

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-stone-200">
      <div className="container flex items-center justify-between h-16">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 no-underline">
          <img
            src="https://files.manuscdn.com/user_upload_by_module/session_file/310419663030265086/VVZZLAPpvULlxcVm.webp"
            alt="Brașov Gateway"
            width={40}
            height={40}
            className="h-10 w-auto object-contain"
          />
          <span className="font-semibold text-stone-800 tracking-wide text-sm uppercase hidden sm:inline" style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "0.12em" }}>
            Brașov Gateway
          </span>
        </a>

        {/* Desktop nav links */}
        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={navHref(l.href, isHome)}
              className="text-sm text-stone-600 hover:text-stone-900 transition-colors no-underline font-light tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </div>

        {/* Language indicator + CTA */}
        <div className="hidden md:flex items-center gap-4">
          <div className="flex items-center gap-1.5">
            <Globe size={13} className="text-stone-400" />
            <span className="text-xs px-1.5 py-0.5 rounded text-white" style={{ backgroundColor: "oklch(0.38 0.12 15)" }}>EN</span>
          </div>
          <a
            href="/contact"
            className="text-xs px-4 py-2 text-white no-underline transition-opacity hover:opacity-90"
            style={{ backgroundColor: "oklch(0.38 0.12 15)", fontFamily: "'Source Sans 3', sans-serif", letterSpacing: "0.08em" }}
          >
            GET IN TOUCH
          </a>
        </div>

        {/* Mobile hamburger */}
        <button className="md:hidden text-stone-700" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={navHref(l.href, isHome)}
              className="text-sm text-stone-700 no-underline"
              onClick={() => setMenuOpen(false)}
            >
              {l.label}
            </a>
          ))}
          <div className="flex items-center gap-1.5 pt-2 border-t border-stone-100">
            <Globe size={13} className="text-stone-400" />
            <span className="text-xs px-2 py-1 rounded text-white" style={{ backgroundColor: "oklch(0.38 0.12 15)" }}>EN</span>
          </div>
        </div>
      )}
    </nav>
  );
}
